<template>
  <v-dialog :value="isOpened" max-width="420px" @input="handleClose">
    <v-card>
      <v-toolbar flat color="warning" dark>
        <v-toolbar-title>
          {{ $t('purchaseV2.leaveConfirmation.title') }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="handleClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="py-6">
        <p class="text-subtitle-1 mb-0 text-center">
          {{ $t('purchaseV2.leaveConfirmation.message') }}
        </p>
      </v-card-text>
      <v-divider />
      <v-card-actions class="mx-1">
        <v-btn text @click="handleClose">
          {{ $t('miscellaneous.cancel') }}
        </v-btn>
        <v-spacer />
        <v-btn color="warning" dark @click="confirm">
          {{ $t('miscellaneous.leave') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LeaveConfirmationDialog',
  props: {
    isOpened: { type: Boolean, required: true },
  },
  methods: {
    confirm() {
      return this.$emit('dialog:confirm')
    },
    handleClose() {
      return this.$emit('dialog:close')
    },
  },
}
</script>
